import React, { Fragment, useEffect, useRef, useState } from "react";
import io from "socket.io-client";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";
import FontAwesomeIcon from "../layout/IME/Icon";
import VolumeRed from "../layout/Mentors/VolumeRed";
import ToggleButton from "../PlayerButtons/ToggleButton";
import { connect } from "react-redux";
import { chatMessage, modChatMessage } from "../../actions/stream";
import { getGifs, getGifsSearch } from "../../actions/gif";
import { getProfileById } from "../../actions/profile";

import LoggedInNavRed from "../layout/IME/LoggedInNavRed";
import StreamChatRed from "../layout/Mentors/StreamChatRed";
import ModChat from "../layout/Mentors/ModChat";
import LiveLinkRequests from "../layout/Mentors/LiveLinkRequests";
import StreamSecondaryLogo from "../layout/IME/StreamSecondaryLogo";

let socket;

const MentorLiveStream = ({
  auth: { user },
  profile: { profile },
  match,
  getProfileById,
  chatMessage,
  modChatMessage,
  getGifs,
  gif: { gifs, loading },
  isAuthenticated,
}) => {
  const ENDPOINT = "localhost:5000";

  const [participant, setParticipant] = useState({
    id: "",
    channelid: user.channelid,
    role: user.role,
    avatar: user.avatar,
    firstname: user.firstname,
    lastname: user.lastname,
    room: match.params.channelid,
  });
  const [liveLinks, setLiveLinks] = useState([]);
  const [showGIFs, setshowGIFs] = useState(false);
  const [showModGIFs, setshowModGIFs] = useState(false);
  const [gifSearch, setGifSearch] = useState(false);
  const [modGifSearch, setModGifSearch] = useState(false);
  const [text, setText] = useState("");
  const [foundGif, setGif] = useState("");
  const [foundModGif, setModGif] = useState("");
  const [message, setMessage] = useState("");
  const [modmessage, setModMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [modmessages, setModMessages] = useState([]);
  const [room, setRoom] = useState(match.params.channelid);
  const [imeBotAvi, setimebotavi] = useState("Innovate_Me_logo_red.png");
  const [showChat, setShowChat] = useState(true);
  const [showModChat, setShowModChat] = useState(false);

  const maxLength = 100;

  const deleteMessage = (id) => {
    const removeIndex = messages
      .map((message) => message.messageid)
      .indexOf(id);

    messages.splice(removeIndex, 1);

    setMessages([...messages]);
  };

  const deleteModMessage = (id) => {
    const removeIndex = modmessages
      .map((message) => message.messageid)
      .indexOf(id);

    modmessages.splice(removeIndex, 1);

    setModMessages([...modmessages]);
  };

  useEffect(() => {
    getProfileById(match.params.channelid);
  }, [getProfileById, match.params.channelid]);

  // time = evaluate(time);
  // videoduration = evaluate(videoduration);
  const playerRef = useRef(null);
  const videoRef = useRef(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [stream, setStreamLive] = useState();

  useEffect(() => {
    getGifs();
    setRoom(match.params.channelid);
  }, [getGifs, match.params.channelid, room]);

  useEffect(() => {
    if (user) {
      socket = io(ENDPOINT);

      socket.on("roomUsers", (room, users) => {
        console.log(room, users);
      });

      socket.emit("joinRoom", {
        imebotavi: imeBotAvi,
        channelid: user.channelid,
        role: user.role,
        avatar: user.avatar,
        firstname: user.firstname,
        lastname: user.lastname,
        room: match.params.channelid,
      });
    }

    return () => {
      if (socket) {
        socket.emit("leave");

        socket.on("roomUsers", (users) => {
          // setViewerCount([...users.users]);
        });

        socket.disconnect();

        socket.off();
      }
    };
  }, [ENDPOINT, match.params.channelid, user]);

  useEffect(() => {
    socket.on("message", (message) => {
      setMessages([...messages, message]);
    });
  }, [messages]);

  useEffect(() => {
    socket.on("modmessage", (modmessage) => {
      setModMessages([...modmessages, modmessage]);
    });
  }, [modmessages]);

  const sendModMessage = (e) => {
    e.preventDefault();
    if (modmessage || foundModGif !== "") {
      modChatMessage(match.params.channelid, modmessage, foundModGif);
      socket.emit(
        "modChatMessage",
        modmessage,
        foundModGif,
        user.firstname,
        user.lastname,
        user.avatar,
        room
      );
      setModMessage("");
      setModGif("");
      setshowModGIFs(false);
    }
  };

  const sendMessage = (e) => {
    e.preventDefault();
    if (message || foundGif !== "") {
      chatMessage(match.params.channelid, message, foundGif);
      socket.emit(
        "chatMessage",
        message,
        foundGif,
        user.firstname,
        user.lastname,
        user.avatar,
        room
      );
      setMessage("");
      setGif("");
      setshowGIFs(false);
    }
  };

  const removeRequest = (channelid) => {
    setLiveLinks(liveLinks.filter((item) => item.id !== channelid));
    socket.emit("removeRequest", participant);
  };

  useEffect(() => {
    socket.on("sendRequests", (userRequests) => {
      setLiveLinks(userRequests);
    });
  }, [liveLinks]);

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.channelid !== "roland") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      <LoggedInNavRed />
      <section
        className={showChat || showModChat ? "flex-only-alt" : "flex-no-chat"}
      >
        <LiveLinkRequests
          liveLinks={liveLinks}
          removeRequest={removeRequest}
          setParticipant={setParticipant}
        />
        <div className="main-stream-content">
          <div className="video-chat grey" ref={playerRef}>
            <div className="live-stream-video-container">
              <div className="user-overlay-alt">
                <div
                  className={
                    showChat
                      ? "video-stream-live red"
                      : "video-stream-live-chat red"
                  }
                >
                  <i className="fas fa-circle mx-5"></i>
                  Live
                </div>
                <div className="alt-left-controls">
                  <ul className="controls">
                    <VolumeRed
                      className="Rac__volume"
                      onChange={(level) => {
                        const volume = level / 100;
                        videoRef.current.volume = volume;
                        videoRef.current.muted = volume === 0;
                      }}
                    />
                  </ul>
                </div>
                <div className="icon-flex-expand-settings">
                  <ToggleButton
                    className="Rac__screen-toggle"
                    initial={document.fullscreenElement}
                    onChange={(active) => {
                      if (!active && KeyboardEvent.key === "Escape") {
                        return document.exitFullscreen();
                      }

                      return playerRef.current.requestFullscreen({
                        navigationUI: "hide",
                      });
                    }}
                  >
                    {(active) => {
                      if (!active) {
                        return (
                          <FontAwesomeIcon
                            icon="expand"
                            size="lg"
                            className="mt-4 red"
                          />
                        );
                      }

                      if (active) {
                        return (
                          <FontAwesomeIcon
                            icon="compress"
                            size="lg"
                            className="mt-4 red"
                          />
                        );
                      }
                    }}
                  </ToggleButton>
                  <ToggleButton className="">
                    {(showSettings) => {
                      if (showSettings) {
                        return (
                          <div className="relative-button-container">
                            <li className="control red">
                              <i className="fas fa-cog fa-lg icon-padding"></i>
                            </li>
                            <div className="video-settings">
                              <ul className="video-setting">
                                <li className="video-option red bold">
                                  Quality
                                </li>
                                <li className="video-option white cursor">
                                  Auto
                                  <i className="fas fa-chevron-right white mx-10"></i>
                                </li>
                              </ul>
                              <ul className="video-setting">
                                <li className="video-option red bold">
                                  Caption
                                </li>
                                <li className="video-option white cursor">
                                  Off
                                  <i className="fas fa-chevron-right white mx-10"></i>
                                </li>
                              </ul>
                              <ul className="video-setting">
                                <li className="video-option red bold">
                                  Report Issue
                                </li>
                                <li className="video-option white cursor">
                                  <i className="fas fa-chevron-right white mx-10"></i>
                                </li>
                              </ul>
                              <ul className="video-setting">
                                <li className="video-option red bold">
                                  Advanced
                                </li>
                                <li className="video-option white cursor">
                                  <i className="fas fa-chevron-right white mx-10"></i>
                                </li>
                              </ul>
                            </div>
                          </div>
                        );
                      }

                      return (
                        <div className="relative-button-container">
                          <li className="control red">
                            <i className="fas fa-cog fa-lg icon-padding"></i>
                          </li>
                        </div>
                      );
                    }}
                  </ToggleButton>
                </div>
              </div>
              <video
                ref={videoRef}
                className="fill-video"
                autoPlay={true}
              ></video>
            </div>
            {!showChat && !showModChat && (
              <div className="showchaticon" onClick={() => setShowChat(true)}>
                <i className="far fa-comment fa-2x red"></i>
              </div>
            )}
          </div>
          <div className="stream-information-container">
            <div className="stream-info-grid">
              <div className="stream-grid-container">
                <div className="stream-info">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${profile.avatar}`}
                    className="streamer-user-avi"
                  />
                  <div className="helper-container">
                    <p className="stream-description">
                      Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                      Nam ratione aut eaque dolor ea temporibus laboriosam
                      laborum recusandae odio omnis.
                    </p>
                    {/* <div className="stream-keywords">
                      <ul>
                        {live_discussion.keywords.length > 0 &&
                          live_discussion.keywords.map((keyword) => {
                            return (
                              <li
                                className="stream-text-keywords red"
                                key={keyword._id}
                              >
                                {keyword.text}
                              </li>
                            );
                          })}
                      </ul>
                    </div> */}
                    <div className="stream-lower-info">
                      <ul className="creator-stream-items">
                        <li class="stream-item red bold">
                          {profile.channelid}
                        </li>
                        <li className="stream-item">
                          {profile.firstname} {profile.lastname}
                        </li>
                        <li class="stream-item">{profile.jobtitle}</li>
                        <li className="stream-item">
                          {profile.location && profile.location.city},{" "}
                          {profile.location && profile.location.state}
                        </li>
                        <li className="stream-item">
                          <i className="far fa-clock mr-5 red"></i>
                          Date
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="stream-grid-container">
                <StreamSecondaryLogo />
              </div>
            </div>
          </div>
          <div className="margin-top"></div>
        </div>
        {showModChat && !showChat && (
          <ModChat
            user={user}
            profile={profile}
            modmessages={modmessages}
            modmessage={modmessage}
            setModMessage={setModMessage}
            deleteModMessage={deleteModMessage}
            gifs={gifs}
            setModGif={setModGif}
            foundModGif={foundModGif}
            showModGIFs={showModGIFs}
            setshowModGIFs={setshowModGIFs}
            modGifSearch={modGifSearch}
            setModGifSearch={setModGifSearch}
            sendModMessage={sendModMessage}
            text={text}
            setShowModChat={setShowModChat}
            setShowChat={setShowChat}
            maxLength={maxLength}
          />
        )}
        {showChat && !showModChat && (
          <StreamChatRed
            user={user}
            profile={profile}
            messages={messages}
            message={message}
            setMessage={setMessage}
            deleteMessage={deleteMessage}
            gifs={gifs}
            setGif={setGif}
            foundGif={foundGif}
            showGIFs={showGIFs}
            setshowGIFs={setshowGIFs}
            gifSearch={gifSearch}
            setGifSearch={setGifSearch}
            sendMessage={sendMessage}
            text={text}
            setText={setText}
            setShowChat={setShowChat}
            setShowModChat={setShowModChat}
            maxLength={maxLength}
          />
        )}
      </section>
    </Fragment>
  );
};

MentorLiveStream.propTypes = {
  auth: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  getProfileById: PropTypes.func.isRequired,
  chatMessage: PropTypes.func.isRequired,
  modChatMessage: PropTypes.func.isRequired,
  getGifs: PropTypes.func.isRequired,
  getGifsSearch: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  profile: state.profile,
  gif: state.gif,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {
  getProfileById,
  chatMessage,
  modChatMessage,
  getGifs,
  getGifsSearch,
})(MentorLiveStream);
